import { getOwnersByProjectRepository } from "../Infrastructure/Owners.repository";

export async function getOwnersByProjectLogic(id) {
  return getOwnersByProjectRepository(id);
}